<template>
  <div class="d-flex col-12">
    <div class="col-12 d-flex date-box align-items-end">
      <div
        class="d-flex col-12 date-input"
        style="position: relative; bottom: 0; white-space: pre-line"
      >
        <div :id="'datepicker' + ids">
          <div
            :id="'showpointeryear' + ids"
            class="Bubblebox year"
            style="
              position: absolute;
              bottom: 225px;
              z-index: 1000001;
              display: none;
            "
          >
            クリックすると年選択ができる
          </div>
          <div
            :id="'showpointermonth' + ids"
            class="Bubblebox month"
            style="
              position: absolute;
              bottom: 315px;
              z-index: 1000001;
              display: none;
            "
          >
            クリックすると月選択ができる
          </div>
          <Datepicker
            :ref="dref"
            v-model="datetmp"
            :class="'datepickers' + ids"
            :disabled="disabled"
            :highlighted="highlighted"
            :monday-first="true"
            :language="ja"
            wrapper-class="calender-text-box-wrapper"
            :format="customFormatter"
            :typeable="true"
          />
        </div>

        <input
          :id="'dateinput' + ids"
          :ref="iref"
          v-model="datewa"
          :disabled="disabled"
          type="text"
          class="form-control input-height"
          :style="'width:' + width"
          @click="calendar()"
          @blur="closeCalendar()"
        />
        <div class="ms-1">
          <img class="icon" src="@/assets/カレンダー.png" @click="calendar()" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { BIconLock } from 'bootstrap-vue'
import Datepicker from 'vuejs-datepicker'
import { ja } from 'vuejs-datepicker/dist/locale'
export default {
  name: 'DatePickerTE',
  components: {
    Datepicker
  },
  props: {
    disabled: Boolean,
    dateYMD: String,
    iref: String,
    dref: String,
    width: String,
    posl: Boolean,
    post: Boolean,
    ids: String,
    dialog: Boolean,
    top: Boolean,
    caserecord: Boolean
  },
  data() {
    return {
      ja: ja,
      datetmp: '',
      datewa: '',
      showpointeryear: false,
      showpointermonth: false,
      windowHeight: document.documentElement.clientHeight,
      year: '',
      month: '',
      highlighted: {
        to: new Date(2016, 0, 5), // Highlight all dates up to specific date
        from: new Date(2016, 0, 26), // Highlight all dates after specific date
        daysOfMonth: [],
        dates: [
          new Date(2016, 9, 16),
          new Date(2016, 9, 17),
          new Date(2016, 9, 18)
        ],
        includeDisabled: true
      }
    }
  },
  watch: {
    dateYMD: {
      immediate: true,
      handler(value) {
        this.datetmp = value
      }
    }
  },
  mounted() {},
  methods: {
    holidays(year, month) {
      const that = this
      that.highlighted.daysOfMonth = []
      var holidays = this.$store.state.holidays
      // console.log(holidays)
      holidays.forEach(element => {
        if (element.month === month) {
          that.highlighted.daysOfMonth.push(element.date)
        }
      })
    },
    handleScroll() {
      if (this.dialog === true) {
        this.closeCalendar()
      }
    },
    datepickerinput() {
      this.$emit('oninputDate', this.converwatoymd(this.datewa))
    },
    customFormatter(dat) {
      if (this.datetmp !== '') {
        var date = new Date(dat)
        var year = date.getFullYear()
        var ear = ''
        var sYear = 0
        if (year > 2018) {
          ear = '令和'
          sYear = year - 2018
        } else if (year > 1988) {
          ear = '平成'
          sYear = year - 1988
        } else if (year > 1925) {
          ear = '昭和'
          sYear = year - 1925
        } else if (year > 1911) {
          ear = '大正'
          sYear = year - 1911
        } else {
          ear = '明治'
          sYear = year - 1867
        }
        this.datewa =
          ear +
          '' +
          sYear +
          '年' +
          (date.getMonth() + 1 + '').padStart(2, '0') +
          '月' +
          (date.getDate() + '').padStart(2, '0') +
          '日'
      }
      return ''
    },
    converwatoymd(wa) {
      try {
        if (wa === '') {
          return ''
        }
        var ear = wa.substr(0, 2)
        var idx = wa.indexOf('年')
        var year = Number(wa.substring(2, idx))
        var idxM = wa.indexOf('月')
        var smonth = wa.substring(idx + 1, idxM)
        var idxD = wa.indexOf('日')
        var sday = wa.substring(idxM + 1, idxD)
        if (ear === '令和') {
          year = year + 2018
        } else if (ear === '平成') {
          year = year + 1988
        } else if (ear === '昭和') {
          year = year + 1925
        } else if (ear === '大正') {
          year = year + 1911
        } else {
          year = year + 1867
        }
        return year + '/' + smonth + '/' + sday
      } catch (ex) {
        return ''
      }
    },
    calendar() {
      const that = this
      window.addEventListener('scroll', this.handleScroll, true)
      var idone =
        '#datepicker' +
        this.ids +
        ' .vdp-datepicker__calendar header span.month__year_btn'
      var idtow =
        '#datepicker' +
        this.ids +
        ' .vdp-datepicker__calendar header span.day__month_btn'
      var idnext =
        '#datepicker' + this.ids + ' .vdp-datepicker__calendar header span.next'
      var idprev =
        '#datepicker' + this.ids + ' .vdp-datepicker__calendar header span.prev'
      var idoneyaer = '#showpointeryear' + this.ids
      var idonemonth = '#showpointermonth' + this.ids
      var idoffset = '#dateinput' + this.ids
      var idpickerparents = '#datepicker' + this.ids
      var idpicker = '.datepickers' + this.ids
      var datepickerheight = $(idpicker)
        .find('.vdp-datepicker__calendar')
        .eq(0)
        .height()
      that.year = Number(
        $(idpicker)
          .find('.vdp-datepicker__calendar .day__month_btn')
          .html()
          .substring(0, 4)
      )
      var y = $(idpicker)
        .find('.vdp-datepicker__calendar .day__month_btn')
        .html()
        .indexOf('年')
      var m = $(idpicker)
        .find('.vdp-datepicker__calendar .day__month_btn')
        .html()
        .indexOf('月')
      that.month = Number(
        $(idpicker)
          .find('.vdp-datepicker__calendar .day__month_btn')
          .html()
          .substring(y + 1, m)
      )
      that.holidays(that.year, that.month)
      $(idnext).on('click', function() {
        that.year = Number(
          $(idpicker)
            .find('.vdp-datepicker__calendar .day__month_btn')
            .html()
            .substring(0, 4)
        )
        var y = $(idpicker)
          .find('.vdp-datepicker__calendar .day__month_btn')
          .html()
          .indexOf('年')
        var m = $(idpicker)
          .find('.vdp-datepicker__calendar .day__month_btn')
          .html()
          .indexOf('月')
        that.month = Number(
          $(idpicker)
            .find('.vdp-datepicker__calendar .day__month_btn')
            .html()
            .substring(y + 1, m)
        )
        that.holidays(that.year, that.month)
        $(idpicker)
          .find('.vdp-datepicker__calendar .year')
          .on('click', function() {
            that.year = Number($(this).html())
            that.holidays(that.year, that.month)
            $(idpicker)
              .find('.vdp-datepicker__calendar .month')
              .on('click', function() {
                const m = $(this).html().indexOf('月')
                that.month = Number($(this).html().substring(0, m))
                that.holidays(that.year, that.month)
              })
          })
      })
      $(idprev).on('click', function() {
        that.year = Number(
          $(idpicker)
            .find('.vdp-datepicker__calendar .day__month_btn')
            .html()
            .substring(0, 4)
        )
        var y = $(idpicker)
          .find('.vdp-datepicker__calendar .day__month_btn')
          .html()
          .indexOf('年')
        var m = $(idpicker)
          .find('.vdp-datepicker__calendar .day__month_btn')
          .html()
          .indexOf('月')
        that.month = Number(
          $(idpicker)
            .find('.vdp-datepicker__calendar .day__month_btn')
            .html()
            .substring(y + 1, m)
        )
        that.holidays(that.year, that.month)
        $(idpicker)
          .find('.vdp-datepicker__calendar .year')
          .on('click', function() {
            that.year = Number($(this).html())
            that.holidays(that.year, that.month)
            $(idpicker)
              .find('.vdp-datepicker__calendar .month')
              .on('click', function() {
                const m = $(this).html().indexOf('月')
                that.month = Number($(this).html().substring(0, m))
                that.holidays(that.year, that.month)
              })
          })
      })
      $(idpicker)
        .find('.vdp-datepicker__calendar .year')
        .on('click', function() {
          that.year = Number($(this).html())
          that.holidays(that.year, that.month)
          $(idpicker)
            .find('.vdp-datepicker__calendar .month')
            .on('click', function() {
              const m = $(this).html().indexOf('月')
              that.month = Number($(this).html().substring(0, m))
              that.holidays(that.year, that.month)
            })
        })
      $(idpicker)
        .find('.vdp-datepicker__calendar .month')
        .on('click', function() {
          const m = $(this).html().indexOf('月')
          that.month = Number($(this).html().substring(0, m))
          that.holidays(that.year, that.month)
        })
      if (this.posl === true) {
        var l = $('.date-input').width() - 322
        $('.vdp-datepicker__calendar').css('margin-left', l + 'px')
        $('.Bubblebox').css('margin-left', l + 46 + 'px')
      } else {
        $('.vdp-datepicker__calendar').css('margin-left', '0px')
        $('.Bubblebox').css('margin-left', '46px')
      }
      if (this.post === true) {
        $('.vdp-datepicker__calendar').css('margin-top', '-285px')
        $('.Bubblebox.year').css('bottom', '225px')
        $('.Bubblebox.month').css('bottom', '315px')
        $(idtow).on('click', function() {
          $('.vdp-datepicker__calendar').css('margin-top', '-205px')
        })
      } else {
        $('.vdp-datepicker__calendar').css('margin-top', '30px')
        $('.Bubblebox.year').css('bottom', '0')
        $('.Bubblebox.month').css('bottom', '0')
      }
      if (this.dialog === true) {
        var left = $(idoffset).offset().left - $(window).scrollLeft()
        var top = $(window).scrollTop()
        var topheignt = $(idoffset).offset().top - $(window).scrollTop()
        $(idpickerparents).css('position', 'fixed')
        $(idpickerparents).css('left', left + 'px')
        $(idpickerparents).css('z-index', '1111')
        if (top === 0) {
          if (topheignt < 315) {
            $('.vdp-datepicker__calendar').css('margin-top', '30px')
            $('.vdp-datepicker__calendar').css('bottom', 'auto')
            $('.Bubblebox.year').css('bottom', '-30px')
            $('.Bubblebox.month').css('bottom', '-30px')
            $(idpickerparents).css('top', topheignt + 'px')
          } else if (topheignt < 350 && this.caserecord === true) {
            $('.vdp-datepicker__calendar').css('margin-top', '30px')
            $('.Bubblebox.year').css('bottom', '-30px')
            $('.Bubblebox.month').css('bottom', '-30px')
            $('.vdp-datepicker__calendar').css('bottom', 'auto')
            $(idpickerparents).css('top', topheignt + 'px')
          } else {
            if (this.top === true) {
              $('.vdp-datepicker__calendar').css('bottom', '5px')
              $('.Bubblebox.month').css('bottom', '325px')
              $('.Bubblebox.year').css('bottom', '205px')
              $(idpickerparents).css('top', topheignt + 'px')
              if (datepickerheight > 300) {
                $('.Bubblebox.month').css('bottom', '325px')
              } else {
                $('.Bubblebox.month').css('bottom', '285px')
              }
              $(idnext).on('click', function () {
                datepickerheight = $(idpicker)
                  .find('.vdp-datepicker__calendar')
                  .eq(0)
                  .height()
                if (datepickerheight > 300) {
                  $('.Bubblebox.month').css('bottom', '325px')
                } else {
                  $('.Bubblebox.month').css('bottom', '285px')
                }
              })
              $(idprev).on('click', function () {
                datepickerheight = $(idpicker)
                  .find('.vdp-datepicker__calendar')
                  .eq(0)
                  .height()
                if (datepickerheight > 300) {
                  $('.Bubblebox.month').css('bottom', '325px')
                } else {
                  $('.Bubblebox.month').css('bottom', '285px')
                }
              })
            } else {
              $('.vdp-datepicker__calendar').css('bottom', '40px')
              $('.Bubblebox.month').css('bottom', '320px')
              $('.Bubblebox.year').css('bottom', '245px')
              $(idpickerparents).css('top', topheignt + 38 + 'px')
              if (datepickerheight > 300) {
                $('.Bubblebox.month').css('bottom', '360px')
              } else {
                $('.Bubblebox.month').css('bottom', '325px')
              }
              $(idnext).on('click', function () {
                datepickerheight = $(idpicker)
                  .find('.vdp-datepicker__calendar')
                  .eq(0)
                  .height()
                if (datepickerheight > 300) {
                  $('.Bubblebox.month').css('bottom', '360px')
                } else {
                  $('.Bubblebox.month').css('bottom', '325px')
                }
              })
              $(idprev).on('click', function () {
                datepickerheight = $(idpicker)
                  .find('.vdp-datepicker__calendar')
                  .eq(0)
                  .height()
                if (datepickerheight > 300) {
                  $('.Bubblebox.month').css('bottom', '360px')
                } else {
                  $('.Bubblebox.month').css('bottom', '325px')
                }
              })
            }
          }
        } else {
          if (topheignt < 270) {
            $('.vdp-datepicker__calendar').css('margin-top', '30px')
            $('.Bubblebox.year').css('bottom', '-30px')
            $('.Bubblebox.month').css('bottom', '-30px')
            $('.vdp-datepicker__calendar').css('bottom', 'auto')
            $(idpickerparents).css('top', topheignt + 'px')
          } else {
            $('.vdp-datepicker__calendar').css('margin-top', '-325px')

            if (this.top === true) {
              $('.vdp-datepicker__calendar').css('bottom', '5px')
              $('.Bubblebox.month').css('bottom', '325px')
              $('.Bubblebox.year').css('bottom', '205px')
              $(idpickerparents).css('top', topheignt + 'px')
              if (datepickerheight > 300) {
                $('.Bubblebox.month').css('bottom', '325px')
              } else {
                $('.Bubblebox.month').css('bottom', '285px')
              }
              $(idnext).on('click', function () {
                datepickerheight = $(idpicker)
                  .find('.vdp-datepicker__calendar')
                  .eq(0)
                  .height()
                if (datepickerheight > 300) {
                  $('.Bubblebox.month').css('bottom', '325px')
                } else {
                  $('.Bubblebox.month').css('bottom', '285px')
                }
              })
              $(idprev).on('click', function () {
                datepickerheight = $(idpicker)
                  .find('.vdp-datepicker__calendar')
                  .eq(0)
                  .height()
                if (datepickerheight > 300) {
                  $('.Bubblebox.month').css('bottom', '325px')
                } else {
                  $('.Bubblebox.month').css('bottom', '285px')
                }
              })
            } else if (topheignt < 350 && this.caserecord === true) {
              $('.vdp-datepicker__calendar').css('margin-top', '30px')
              $('.Bubblebox.year').css('bottom', '-30px')
              $('.Bubblebox.month').css('bottom', '-30px')
              $('.vdp-datepicker__calendar').css('bottom', 'auto')
              $(idpickerparents).css('top', topheignt + 'px')
            } else {
              $('.vdp-datepicker__calendar').css('bottom', '40px')
              $(idpickerparents).css('top', topheignt + 38 + 'px')
              $('.Bubblebox.year').css('bottom', '245px')
              $('.Bubblebox.month').css('bottom', '320px')
              if (datepickerheight > 300) {
                $('.Bubblebox.month').css('bottom', '360px')
              } else {
                $('.Bubblebox.month').css('bottom', '325px')
              }
              $(idnext).on('click', function () {
                datepickerheight = $(idpicker)
                  .find('.vdp-datepicker__calendar')
                  .eq(0)
                  .height()
                if (datepickerheight > 300) {
                  $('.Bubblebox.month').css('bottom', '360px')
                } else {
                  $('.Bubblebox.month').css('bottom', '325px')
                }
              })
              $(idprev).on('click', function () {
                datepickerheight = $(idpicker)
                  .find('.vdp-datepicker__calendar')
                  .eq(0)
                  .height()
                if (datepickerheight > 300) {
                  $('.Bubblebox.month').css('bottom', '360px')
                } else {
                  $('.Bubblebox.month').css('bottom', '325px')
                }
              })
            }
          }
        }
      }
      if (!this.$refs[this.dref].isOpen) {
        this.$refs[this.iref].focus()
        this.datetmp = this.converwatoymd(this.datewa)
        this.$refs[this.dref].showCalendar()
      } else {
        this.$refs[this.dref].close()
      }

      $(idone).hover(
        function() {
          $(idoneyaer).show()
        },
        function() {
          $(idoneyaer).hide()
        }
      )
      $(idtow).hover(
        function() {
          $(idonemonth).show()
        },
        function() {
          $(idonemonth).hide()
        }
      )
    },
    closeCalendar() {
      this.$refs[this.dref].close()
      window.removeEventListener('scroll', this.handleScroll, true)
      var yearname = this.datewa.substring(0, 2)
      var value = this.datewa
      var flg = false
      if (
        yearname !== '令和' &&
        yearname !== '平成' &&
        yearname !== '昭和' &&
        yearname !== '大正' &&
        yearname !== '明治'
      ) {
        flg = true
      } else {
        flg = false
      }
      if (
        this.datewa !== '' &&
        this.datewa.length > 7 &&
        this.datewa.length < 11 &&
        flg === true
      ) {
        var date = ''
        if (
          this.datewa.indexOf('/') !== -1 ||
          this.datewa.indexOf('-') !== -1
        ) {
          date = new Date(this.datewa)
        } else {
          if (this.datewa.length < 9) {
            var pattern = /(\d{4})(\d{2})(\d{2})/
            var newDate = this.datewa.replace(pattern, '$1-$2-$3')
            date = new Date(newDate)
          } else {
            this.datewa = ''
            return
          }
        }
        var year = date.getFullYear()
        var ear = ''
        var sYear = 0
        if (year > 2018) {
          ear = '令和'
          sYear = year - 2018
        } else if (year > 1988) {
          ear = '平成'
          sYear = year - 1988
        } else if (year > 1925) {
          ear = '昭和'
          sYear = year - 1925
        } else if (year > 1911) {
          ear = '大正'
          sYear = year - 1911
        } else {
          ear = '明治'
          sYear = year - 1867
        }

        if (
          sYear !== 'NaN' &&
          (date.getMonth() + 1 + '').padStart(2, '0') !== 'NaN' &&
          (date.getDate() + '').padStart(2, '0') !== 'NaN'
        ) {
          this.datewa =
            ear +
            '' +
            sYear +
            '年' +
            (date.getMonth() + 1 + '').padStart(2, '0') +
            '月' +
            (date.getDate() + '').padStart(2, '0') +
            '日'
          this.datepickerinput()
        } else {
          this.datewa = ''
        }
      } else {
        if (
          yearname === '令和' ||
          yearname === '平成' ||
          yearname === '昭和' ||
          yearname === '大正' ||
          yearname === '明治'
        ) {
          this.datewa = value
          this.datepickerinput()
        } else {
          this.datewa = ''
        }
      }
    }
  }
}
</script>
<style lang="scss">
.vdp-datepicker input {
  display: none;
}
.vdp-datepicker__calendar {
  margin-top: 30px;
  z-index: 1000000 !important;
}
.input-height {
  height: 25px !important;
}
.vdp-datepicker__calendar header span:hover {
  content: '123';
}
.Bubblebox {
  border-width: 1px;
  padding: 5px;
  border-radius: 10px;
  background-color: rgba(0, 0, 0, 0.6);
  color: #fff;
  text-align: center;
  width: 210px;
}
.Bubblebox::before {
  content: '';
  width: 0;
  height: 0;
  border: 10px solid;
  position: absolute;
  bottom: -20px;
  left: 45%;
  border-color: rgba(0, 0, 0, 0) transparent transparent;
}
.Bubblebox::after {
  content: '';
  width: 0;
  height: 0;
  border: 10px solid;
  position: absolute;
  bottom: -20px;
  left: 45%;
  border-color: rgba(0, 0, 0, 0.6) transparent transparent;
}
.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day.weekend.sat {
  color: rgb(50, 102, 222);
}
.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day.weekend.sun {
  color: red;
}
.vdp-datepicker__calendar .cell.day.highlighted {
  background: none !important;
  color: red;
}
.vdp-datepicker__calendar .cell.day.selected.highlighted {
  background: #4bd !important;
}
</style>
